import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

export var NoDecoratedControllerError = /*#__PURE__*/function (_Error) {
  _inherits(NoDecoratedControllerError, _Error);

  var _super = _createSuper(NoDecoratedControllerError);

  function NoDecoratedControllerError(name) {
    _classCallCheck(this, NoDecoratedControllerError);

    return _super.call(this, "The class ".concat(name, " has not been decorated with @Controller() but it's being used as one. Please, use @Controller() to decorate the class."));
  }

  return NoDecoratedControllerError;
}( /*#__PURE__*/_wrapNativeSuper(Error));